<template>
  <div class="empty">
    <template v-if="type === 'pie-chart'">
      <img :src="getImage('empty/empty-pie-chart.svg')" alt="Chart" />
      <p>No data</p>
    </template>
    <template v-else-if="type === 'line-chart'">
      <img
        :src="getImage('empty/empty-line-chart.svg')"
        class="line"
        alt="Chart"
      />
      <p>No data</p>
    </template>
  </div>
</template>

<script>
export default {
  name: "RaEmptyState",
  props: {
    type: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.empty {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    height: 150px;
    width: auto;
    margin: 15px 0 15px;

    &.line {
      height: 150px;
    }
  }

  p {
    opacity: 0.5;
  }
}
</style>
